import React from "react";

import "./css/quienesSomos.css"

import linkedin from "./assets/icons/linkedin.png"
import twitter from "./assets/icons/twitter.png"

import lucia from "./assets/colaboradores/lucia.jpg"
import victoria from "./assets/colaboradores/victoria.jfif";
import joana from "./assets/colaboradores/joana2.jpeg";
import amal from "./assets/colaboradores/amal.jpeg";
import adriana from "./assets/colaboradores/adriana.png";
import mar from "./assets/colaboradores/mar2.jpeg";

import emma from "./assets/colaboradores/emma.jpg";
import arturo from "./assets/colaboradores/arturo.jpg";
import max from "./assets/colaboradores/max.jfif";
import oscar from "./assets/colaboradores/oscar.jpeg";
import inma from "./assets/colaboradores/inma.jpg";
import edgar from "./assets/colaboradores/edgar.jpeg";
import martin from "./assets/colaboradores/martin.jpg";
import pablo from "./assets/colaboradores/pablo.jpeg";
import jordi from "./assets/colaboradores/jordi.jfif";
import miquel from "./assets/colaboradores/miquel.jfif";

import jacobo from "./assets/colaboradores/jacobo.png";
import cesc from "./assets/colaboradores/cesc.jfif";
import izan from "./assets/colaboradores/izan.jpg";
import david from "./assets/colaboradores/david.jfif";
import ferran from "./assets/colaboradores/ferran.png";
import marta from "./assets/colaboradores/marta.jpeg";
import joan from "./assets/colaboradores/joan.jfif";
import paula from "./assets/colaboradores/paula.jpeg";
import alexandra from "./assets/colaboradores/alexandra.webp";
import mireia from "./assets/colaboradores/mireia.jpg";
import teresa from "./assets/colaboradores/teresa.jpg"

import blanca from "./assets/colaboradores/blanca.jpeg";

const ListaPersonas = ({titulo, personas}) => {
    return (
        <>
            <h2>{titulo}</h2>
            <div className="grid">
                {personas.map((persona, index) => (
                    <div className="grid-item" key={index}>
                        <h3>{persona.nombre}</h3>
                        <div className="img-div"><img src={persona.foto}/></div>
                        <p>{persona.descripcion}</p>
                        <div className="social">
                            {persona.linkedin !== "" && <a href={persona.linkedin} target="_blank" rel="noopener noreferrer"><img src={linkedin}/></a>}
                            {persona.twitter !== "" && <a href={persona.twitter} target="_blank" rel="noopener noreferrer"><img src={twitter}/></a>}
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}

export default function QuienesSomos() {
    const organizadoras = [
        {
            nombre: "María Lucía Aparicio García",
            foto: lucia,
            descripcion: "Lucía estudia Matemáticas e Ingeniería Informática en la Universitat Politècnica de Catalunya a través del programa CFIS. Fue la ganadora de las dos primeras ediciones de la Olimpiada Informática Femenina y obtuvo una medalla de plata y una de bronce en la Olimpiada Europea Informática Femenina, representando a España, además de dos medallas de plata en la Olimpiada Informática Española. Preside la Junta Directiva de la OIFem, donde además es directora de la sección de concursos y profesora.",
            linkedin: "",
            twitter: "",
        },
        {
            nombre: "Victoria Durán Fernández",
            foto: victoria,
            descripcion: "Victoria está estudiando Matemáticas en la Universidad de Bonn. Formó parte de la primera edición de la OIFem, donde obtuvo una medalla de plata (segundo puesto nacional). Ahora quiere que otras jóvenes puedan disfrutar de esta experiencia también, por lo que lleva colaborando como voluntaria desde su segunda edición. Ahora es vicepresidenta de la OIFem y se encarga de las relaciones institucionales.",
            linkedin: "",
            twitter: "",
        },
        {
            nombre: "Joana Pech Alberich",
            foto: joana,
            descripcion: "Joana está estudiando Matemáticas y Ciencia e Ingeniería de Datos en la Universitat Politècnica de Catalunya a través del programa CFIS. Obtuvo una medalla de plata en la Olimpiada Europea Matemática Femenina (EGMO 2020), donde representaba a España, y una de bronce en el SWERC, donde representaba a la UPC. Fue finalista de la OIFem I y ahora además de ser secretaria dirige la parte educativa de la asociación, es profesora y creadora de problemas.",
            linkedin: "https://www.linkedin.com/in/joana-pech-alberich-5ab507212/",
            twitter: "",
        },
        {
            nombre: "Amal Dokkar El Hamoudi",
            foto: amal,
            descripcion: "Amal participó en las tres primeras ediciones de la OIFem, obteniendo dos medallas de bronce y una de plata a nivel nacional. Siendo medallista, fue a la EGOI (Olimpiada Europea Femenina de Informática) tres veces, ganando una medalla de bronce y una mención de honor. Además, fue una de las tres alumnas que formó el primer equipo femenino en ganar la HP Codewars Spain. Ahora colabora con la OIFem proponiendo problemas y como entrenadora dando clases de nivel intermedio. Dentro de la Junta, se encarga de todas las tareas de diseño gráfico, desde merchandising hasta redes sociales.",
            linkedin: "",
            twitter: "",
        },
        {
            nombre: "Adriana Aguiló Martínez",
            foto: adriana,
            descripcion: "Adriana está estudiando la doble titulación de Matemáticas y Ciencia e Ingeniería de Datos en la Universitat Politècnica de Catalunya a través del programa CFIS. Participó en las tres primeras ediciones de la OIFem, formando parte de la delegación española para la EGOI (Olimpiada Europea Femenina de Informática) en 2022 y 2023, donde obtuvo dos medallas de bronce internacionales. Junto con dos compañeras de la OIFem - Amal Dokkar y Helena Folia -, formaron un equipo que ganó las HP Codewars Spain 2023, siendo el primer equipo íntegramente femenino en ganar la competición. Tras estos años, ha disfrutado mucho compitiendo, y por eso ahora es profesora del nivel intermedio a la vez que crea problemas de concurso. Además, dirige la organización de los eventos no competitivos (charlas, etc.).",
            linkedin: "",
            twitter: "",
        },
        {
            nombre: "Mar Gonzàlez i Català",
            foto: mar,
            descripcion: "Mar estudia Matemáticas e Ingeniería Informática en la Universitat Politècnica de Catalunya a través del programa CFIS. Colaboró con la OIFem como voluntaria en un evento organizado en su facultad y desde entonces es profesora, además de dirigir las comunicaciones de la OIFem.",
            linkedin: "https://www.linkedin.com/in/mar-gonz%C3%A0lez-catal%C3%A0-447a8521a/",
            twitter: "",
        }
    ];

    const voluntarios = [
        {
            nombre: "Jacobo Vilella Vilahur",
            foto: jacobo,
            descripcion: "Jacobo es Chief Information Officer y profesor de Computer Science en Aula Escola Europea, Barcelona. Además, fundó eSeeCode, una plataforma gráfica online para enseñar programación a los más jóvenes de forma gratuita, y es su actual CTO. En la OIFem, es tesorero y se encarga de la organización de eventos.",
            linkedin: "https://www.linkedin.com/in/jacobo-vilella-869b164a/",
            twitter: "",
        },
        {
            nombre: "Cesc Folch Aldehuelo",
            foto: cesc,
            descripcion: "Cesc es estudiante del Máster en Matemáticas Avanzadas e Ingeniería Matemática en la Universitat Politècnica de Catalunya. Cofundó la OIFem y fue su primer vicepresidente. A día de hoy, da soporte a los entrenamientos y diseña y testea problemas de concurso. Es desarrollador de software en PAL Robotics y obtuvo dos medallas de oro en la Olimpiada Informática Española.",
            linkedin: "https://www.linkedin.com/in/cesc-folch-aldehuelo/",
            twitter: "",
        }, 
        {
            nombre: "Izan Beltrán Ferreiro",
            foto: izan,
            descripcion: "Izan estudia Matemáticas en la Universitat Politècnica de Catalunya. Obtuvo una medalla de oro en la Olimpiada Informática Española. Fue secretario de la OIFem, donde ahora colidera la preparación de concursos. Compite a nivel universitario representando a la UPC en el SWERC.",
            linkedin: "https://www.linkedin.com/in/izan-b-827008118/",
            twitter: "https://x.com/izanbf1803",
        },
        {
            nombre: "David García Quintas",
            foto: david,
            descripcion: "David es ingeniero de software y ha trabajado en Waymo, Google, el Lawrence Berkeley National Laboratory y en el CERN. Actualmente es el co-fundador de una startup dedicada al ahorro energético mediate dispositivos IoT. Fue uno de los fundadores de la OIFem y su secretario original. Ahora diseña problemas de concurso y ayuda con la organización de eventos.",
            linkedin: "https://www.linkedin.com/in/dgq/",
            twitter: "",
        },
        {
            nombre: "Ferran Alet Puig",
            foto: ferran,
            descripcion: "Ferran actualmente es un estudiante de doctorado en el departamento de EECS en el MIT, donde hace investigación en Machine Learning. Antes de esto, estudió Matemáticas e Ingeniería Física en la Universitat Politècnica de Catalunya gracias al programa CFIS. En la OIFem, Ferran diseña y prueba problemas de concurso.",
            linkedin: "https://www.linkedin.com/in/ferran-alet/",
            twitter: "",
        },
        {
            nombre: "Marta Sierra Obea",
            foto: marta,
            descripcion: "Marta es estudiante de Ciencia e Ingeniería de Datos e Ingeniería en Tecnologías de Telecomunicación en la Universidad Carlos III de Madrid. Obtuvo la medalla de oro en la primera Olimpiada Informática Aragonesa y fue finalista de la Olimpiada Informática Española. En la OIFem es creadora y tester de problemas.",
            linkedin: "https://www.linkedin.com/in/marta-sierra-obea-b0462122a/",
            twitter: "",
        },
        {
            nombre: "Joan Alemany Flos",
            foto: joan,
            descripcion: "Joan es profesor de IB Matemáticas y Computer Science en Aula Escola Europea, Barcelona. Fundó eSeeCode, plataforma gráfica online para aprender programación, ayudando a los alumnos a pasar de lenguajes gráficos a programar en un IDE. En la OIFem, diseña problemas y ayuda con los entrenamientos semanales del nivel 1.",
            linkedin: "https://www.linkedin.com/in/joan-alemany-flos-21b82141/",
            twitter: "https://x.com/LordBaduk",
        },
        {
            nombre: "Paula Taibo Suárez",
            foto: paula,
            descripcion: "Paula va a estudiar Ingeniería Informática en la Universidad de la Coruña. Fue finalista en la segunda edición de la OIFem y de la Olimpiada Informática Española. En la OIFem diseña problemas, además de encargarse de nuestra comunidad online de concursantes, ayudando a que tengan la mejor experiencia posible.",
            linkedin: "",
            twitter: "",
        },
        {
            nombre: "Alexandra García Flórez",
            foto: alexandra,
            descripcion: "Alexandra está estudiando Bioquímica y Biología Molecular en la Universidad del País Vasco. Formó parte de la primera edición de la OIFem, donde obtuvo una medalla de bronce (tercer puesto nacional). Ahora diseña problemas de concurso para las siguientes generaciones de alumnas OIFem.",
            linkedin: "",
            twitter: "",
        },
        {
            nombre: "Mireia López Bruch",
            foto: mireia,
            descripcion: "Mireia estudia Technical Computer Science en la universidad de Twente. Fue finalista de la primera edición de la OIFem. Se dedica a editar la página web.",
            linkedin: "https://www.linkedin.com/in/mireia-lopez-bruch-0b7768241/",
            twitter: "",
        },
        {
            nombre: "Teresa Marín Marín",
            foto: teresa,
            descripcion: "Teresa estudia el doble grado en Ingeniería Informática y Matemáticas en la Universidad Complutense de Madrid. Ganó cuatro veces la olimpiada matemática regional murciana y fue finalista de la tercera edición de la OIFem. Ha participado también en la Olimpiada Matemática Española (OME), la Olimpiada Europea Matemática Femenina (EGMO) y la Olimpiada Pan-Americana Matemática Femenina (PAGMO) (medalla de plata). Ahora da clases para la OIFem.",
            linkedin: "",
            twitter: ""
        }
    ];

    const antiguosVoluntarios = [
        {
            nombre: "Emma Espinosa",
            foto: emma,
            descripcion: "Emma estudió Ciencias de la Computación en la Universidad de Oxford y fue finalista de la Olimpiada Informática Española. Ahora es ingeniera de backend en Monzo. En la OIFem creaba materiales educativos.",
            linkedin: "https://www.linkedin.com/in/emespinosa/",
            twitter: "",
        },
        {
            nombre: "Arturo Acuaviva",
            foto: arturo,
            descripcion: "Arturo estudió el doble grado de Ingeniería Informática y Matemáticas, y el máster de Ingeniería Informática en la Universidad Complutense de Madrid; ahora trabaja como ingeniero de desarrollo de software en Amazon en el equipo de Kindle Marketing. En la OIFem, fue profesor de las clases de nivel 2.",
            linkedin: "https://www.linkedin.com/in/arturo-acuaviva/",
            twitter: "",
        },
        {
            nombre: "Max Balsells I Pàmies",
            foto: max,
            descripcion: "Max estudió Matemáticas y Ciencia e Ingeniería de Datos en la Universitat Politècnica de Catalunya. Obtuvo una medalla de oro en la Olimpiada Informática Española y en la OIFem era creador de problemas.",
            linkedin: "https://www.linkedin.com/in/max-balsells/",
            twitter: "",
        },
        {
            nombre: "Oscar Balcells Obeso",
            foto: oscar,
            descripcion: "Oscar estudió Matemáticas en la Escuela Politécnica General de Zürich (ETH Zürich). Obtuvo una medalla de oro en la Olimpiada Informática Española y una medalla de bronce en la Olimpiada Internacional de Informática. En la OIFem, se encargaba de la creación de problemas de concurso.",
            linkedin: "",
            twitter: "",
        },
        {
            nombre: "Inmaculada Pérez Garbín",
            foto: inma,
            descripcion: "Inma trabaja como ingeniera de software en Amazon. Estudió el doble grado en Ingeniería Informática y Matemáticas. En la OIFem, fue profesora del nivel 1.",
            linkedin: "https://www.linkedin.com/in/inmaculada-perez-garbin/",
            twitter: "",
        },
        {
            nombre: "Edgar Moreno Martínez",
            foto: edgar,
            descripcion: "Edgar estudió Matemáticas y Ingenieria Informática en la Universitat Politècnica de Catalunya. Compitió en la OIE y en el SWERC-ICPC siendo medallista en ambos. En la OIFem era creador de problemas.",
            linkedin: "",
            twitter: "",
        },
        {
            nombre: "Martín Sánchez-Pedreño Sánchez",
            foto: martin,
            descripcion: "Martín es ingeniero de software en Amazon. Estudió el doble grado de Matemáticas e Informática y el Máster de Big Data de la Universidad de Murcia. En la OIFem era creador de problemas.",
            linkedin: "https://www.linkedin.com/in/martinsps/",
            twitter: "",
        },
        {
            nombre: "Pablo Hidalgo Palencia",
            foto: pablo,
            descripcion: "Pablo es doctorando en la Universidad Complutense de Madrid y el Instituto de Ciencias Matemáticas. Estudió el Máster de Matemáticas Avanzadas de la Universidad Complutense de Madrid y ganó Ada Byron Madrid cuatro veces. En la OIFem, era tester de problemas.",
            linkedin: "",
            twitter: "",
        },
        {
            nombre: "Jordi Rodríguez Manso",
            foto: jordi,
            descripcion: "Jordi estudió Matemáticas y Ciencia e Ingeniería de Datos en la Universitat Politècnica de Catalunya. Obtuvo una medalla de oro en la Olimpiada Informática Española y una de bronce en la Olimpiada Internacional de Informática. En la OIFem era creador de problemas.",
            linkedin: "",
            twitter: "",
        },
        {
            nombre: "Miquel Ortega Sánchez Colomer",
            foto: miquel,
            descripcion: "Miquel estudió el Máster en Matemáticas Avanzadas e Ingeniería Matemática en la Universitat Politècnica de Catalunya. Obtuvo una medalla de oro en la Olimpiada Informática Española. En la OIFem era tester de problemas.",
            linkedin: "",
            twitter: "",
        }
    ];

    const juntaFundadora = [
        {
            nombre: "Blanca Huergo",
            foto: blanca,
            descripcion: "Fundó la OIFem en 2020 y la dirigió hasta finales de 2023. Ahora es una \"Research Engineer\" en Google DeepMind.",
            linkedin: "https://www.linkedin.com/in/blanca-huergo",
            twitter: ""
        },
        {
            nombre: "Jacobo Vilella Vilahur",
            foto: jacobo,
            descripcion: "Jacobo es Chief Information Officer y profesor de Computer Science en Aula Escola Europea, Barcelona. Además, fundó eSeeCode, una plataforma gráfica online para enseñar programación a los más jóvenes de forma gratuita, y es su actual CTO. En la OIFem, es tesorero y se encarga de la organización de eventos.",
            linkedin: "https://www.linkedin.com/in/jacobo-vilella-869b164a/",
            twitter: "",
        },
        {
            nombre: "Izan Beltrán Ferreiro",
            foto: izan,
            descripcion: "Izan estudia Matemáticas en la Universitat Politècnica de Catalunya. Obtuvo una medalla de oro en la Olimpiada Informática Española. Fue secretario de la OIFem, donde ahora colidera la preparación de concursos. Compite a nivel universitario representando a la UPC en el SWERC.",
            linkedin: "https://www.linkedin.com/in/izan-b-827008118/",
            twitter: "https://x.com/izanbf1803",
        },
        {
            nombre: "Cesc Folch Aldehuelo",
            foto: cesc,
            descripcion: "Cesc es estudiante del Máster en Matemáticas Avanzadas e Ingeniería Matemática en la Universitat Politècnica de Catalunya. Cofundó la OIFem y fue su primer vicepresidente. A día de hoy, da soporte a los entrenamientos y diseña y testea problemas de concurso. Es desarrollador de software en PAL Robotics y obtuvo dos medallas de oro en la Olimpiada Informática Española.",
            linkedin: "https://www.linkedin.com/in/cesc-folch-aldehuelo/",
            twitter: "",
        }, 
        {
            nombre: "David García Quintas",
            foto: david,
            descripcion: "David es ingeniero de software y ha trabajado en Waymo, Google, el Lawrence Berkeley National Laboratory y en el CERN. Actualmente es el co-fundador de una startup dedicada al ahorro energético mediate dispositivos IoT. Fue uno de los fundadores de la OIFem y su secretario original. Ahora diseña problemas de concurso y ayuda con la organización de eventos.",
            linkedin: "https://www.linkedin.com/in/dgq/",
            twitter: "",
        },

    ];

    return (
        <>
            <div className="destacado">
                <h1>¿Quiénes somos?</h1>
                <p>
                    La Asociación Promotora de la Olimpiada Informática Femenina está compuesta por apasionados de la tecnología, desde profesores a estudiantes y desarrolladores, que colaboran de 
                    forma totalmente voluntaria para asegurar el éxito de la Olimpiada. Fue fundada en 2020 por una Junta Directiva (presidida por Blanca Huergo Muñoz) que la dirigió hasta finales 
                    de 2023. Fue entonces cuando los miembros fundadores cedieron sus puestos en la Junta a antiguas alumnas y voluntarias para que pudieran ellas tomar las riendas de la Asociación 
                    (presidida ahora por María Lucía Aparicio García, ganadora de las dos primeras ediciones del certamen).
                </p>

                <p>
                    En este apartado hemos querido presentar tanto a las organizadoras como a todos sus voluntarios. Puedes conocer más sobre sus alumnas y ex alumnas en la sección de Histórico.
                </p>
            </div>

            <ListaPersonas titulo="Organizadoras" personas={organizadoras}/>
            <ListaPersonas titulo="Voluntarios" personas={voluntarios}/>
            <ListaPersonas titulo="Junta Fundacional" personas={juntaFundadora}/>
            <ListaPersonas titulo="Antiguos Voluntarios" personas={antiguosVoluntarios}/>
        </>
    );
}